import React from 'react';
import { LOCKED_FUNDING_ROUNDS_IMAGE } from '../mockImages';

const LockedFundingRoundsSection = () => (
    <div
        className="structured-investments-table-shell structured-investments-table-shell--locked"
        aria-hidden="true"
    >
        <div className="structured-investments-table-wrapper structured-investments-table-wrapper--locked">
            <img
                src={LOCKED_FUNDING_ROUNDS_IMAGE}
                alt="Locked funding rounds preview"
                className="structured-investments-table__preview-image structured-investments-table__preview-image--funding-rounds"
            />
        </div>
    </div>
);

export default LockedFundingRoundsSection;
